export default function ForbiddenPage() {
  return <h1>403 - Forbidden</h1>;
}
